import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import PropTypes from "prop-types";
import CheckIcon from "@mui/icons-material/Check";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const CardInfoDomains = ({ domainInfo }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {domainInfo?.map(({ domainName, groups, name }, i) => (
        <Accordion key={`Accordion - ${i}`}>
          <AccordionSummary
            aria-controls="panel1a-content"
            expandIcon={<ExpandMoreIcon />}
            id="panel1a-header"
          >
            <Typography className={classes.heading} color="textSecondary" variant={"h6"}>
              {domainName} - {name}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List
              aria-label="contacts"
              component="nav"
              style={{ position: "relative", overflow: "auto", maxHeight: 220 }}
            >
              {groups.map((g, i) => (
                <ListItem key={g + i} dense>
                  <ListItemIcon>
                    <CheckIcon />
                  </ListItemIcon>
                  <ListItemText primary={g} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

CardInfoDomains.propTypes = {
  domainInfo: PropTypes.array.isRequired,
};

export default CardInfoDomains;
